export default __webpack_public_path__ + "static/Welcome-dc65dcf5d58d93c9a94e85ae2d3d1793.png";